import LoaderComponent from "components/loader"
import {
  formatAmount,
  getDateOfRepayment,
  getFundRequirementDate,
} from "helpers/common"
import { PERMISSIONS } from "helpers/roles"
import { interestFrequency, repaymentSchedule } from "helpers/utils"
import { usePermission } from "hooks/usePermission"
import AlertAccessModal from "modals/alertAccessModal"
import ApproveConfirmationModal from "pages/ICD/confirm/approveConfirmation"
import RejectConfirmationModal from "pages/ICD/confirm/rejectConfirmation"
import CounterFundRequestModal from "pages/InvestorPages/ICDInvestments/counterFundRequestModal"
import React, { useEffect, useState } from "react"
import toast from "react-hot-toast"
import { useSelector } from "react-redux"

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import {
  useIcdRequestsApproveMutation,
  useIcdRequestsRejectMutation,
  useLazyIcdRequestdetailsQuery,
} from "store/api/icds/icdRequests.api"

function InvestorRequestViewModel({
  openInvestorRequest,
  setOpenInvestorRequest,
  id,
  offerType,
}) {
  const [icdData, setIcdData] = useState()

  const [isToast, setIsToast] = useState(false)
  const [actionType, setActionType] = useState() //APPROVE,REJECT
  const { hasPermission } = usePermission()
  const [openAlertModal, setOpenAlertModal] = useState(false)

  const [open, setOpen] = useState(false)
  const [getDetails, { isFetching }] = useLazyIcdRequestdetailsQuery()
  const [onApprove, { isLoading: isApproving }] =
    useIcdRequestsApproveMutation()
  const [onReject, { isLoading: isRejecting }] = useIcdRequestsRejectMutation()
  const { userType } = useSelector((state) => state.user)

  useEffect(() => {
    if (id) {
      onGetDetails()
    }
  }, [id])

  const onGetDetails = async () => {
    try {
      const { data } = await getDetails({ id }).unwrap()
      setIcdData(data)
    } catch (error) {
      toast.error(error?.data?.message, { id: "toasterMessage" })
    }
  }

  return (
    <div>
      <Modal
        isOpen={openInvestorRequest}
        toggle={() => setOpenInvestorRequest(false)}
        centered
        className="investor-request-model-wrapper"
        size="lg"
      >
        <ModalHeader toggle={() => setOpenInvestorRequest(false)}>
          ICD Request: <span> {icdData?.unique_code} </span>
        </ModalHeader>
        <ModalBody>
          {isFetching ? (
            <LoaderComponent />
          ) : (
            <Container fluid>
              <Row>
                <Col xl={12} className="mt-0">
                  <Card style={{ boxShadow: "none" }}>
                    <CardBody className="pt-4">
                      <CardTitle className="mb-4">Investor Details</CardTitle>
                      <Row className="mb-2">
                        <Col xl={6}>
                          <Label
                            htmlFor="horizontal-firstname-Input"
                            className="col-form-label"
                          >
                            Investor Name
                          </Label>
                          <Input
                            disabled
                            name="Name "
                            type="text"
                            className="form-control"
                            id="horizontal-email-id "
                            placeholder="Investor Name"
                            value={icdData?.investor?.name}
                          />
                        </Col>
                        <Col xl={6}>
                          <Label
                            htmlFor="horizontal-firstname-Input"
                            className="col-form-label"
                          >
                            Email Address
                          </Label>
                          <Input
                            disabled
                            name="Name "
                            type="text"
                            className="form-control"
                            id="horizontal-email-id "
                            placeholder="Email Address"
                            value={icdData?.investor?.email}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col xl={6}>
                          <Label
                            htmlFor="horizontal-firstname-Input"
                            className="col-form-label"
                          >
                            Mobile
                          </Label>
                          <Input
                            disabled
                            name="Name "
                            type="text"
                            className="form-control"
                            id="horizontal-email-id "
                            placeholder="Phone No."
                            value={icdData?.investor?.phone}
                          />
                        </Col>
                        <Col xl={6}>
                          <Label
                            htmlFor="horizontal-firstname-Input"
                            className="col-form-label"
                          >
                            PAN
                          </Label>
                          <Input
                            disabled
                            name="Name "
                            type="text"
                            className="form-control"
                            id="horizontal-email-id "
                            placeholder="PAN"
                            value={icdData?.investor?.pan_no}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  <Card style={{ boxShadow: "none" }}>
                    <CardBody className="pt-4">
                      <CardTitle className="mb-4">ICD Details</CardTitle>
                      <Row className="mb-2">
                        <Col xl={12}>
                          <Row className="mb-2">
                            <Col xl={6}>
                              <Label className="col-form-label">
                                Investment Amount
                              </Label>
                              <Input
                                disabled
                                type="text"
                                className="form-control"
                                id="horizontal-firstname-Input"
                                placeholder="Investment Amount"
                                value={`₹ ${formatAmount(icdData?.icds?.amount)}`}
                              />
                            </Col>
                            <Col xl={6}>
                              <Label className="col-form-label">
                                Date of Repayment
                              </Label>
                              <Input
                                disabled
                                type="text"
                                className="form-control"
                                id="horizontal-email-id "
                                placeholder="Date of Repayment"
                                value={getDateOfRepayment(
                                  icdData?.icds?.repayment_date
                                )}
                              />
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xl={6}>
                              <Label className="col-form-label">
                                Tenure(in days)
                              </Label>
                              <Input
                                disabled
                                type="text"
                                className="form-control"
                                placeholder="Tenure"
                                value={icdData?.icds?.tenure}
                              />
                            </Col>
                            <Col xl={6}>
                              <Label className="col-form-label">
                                Interest Rate (%)
                              </Label>
                              <Input
                                disabled
                                type="text"
                                className="form-control"
                                placeholder="Interest Rate"
                                value={icdData?.icds?.interest_rate}
                              />
                            </Col>

                            <Col xl={6}>
                              <Label className="col-form-label">
                                Interest Payment Frequency
                              </Label>
                              <Input
                                disabled
                                type="text"
                                className="form-control"
                                placeholder="Interest Rate"
                                value={
                                  icdData?.icds &&
                                  interestFrequency.find(
                                    (item) =>
                                      item.key ===
                                      icdData?.icds?.interest_frequency
                                  ).label
                                }
                              />
                            </Col>

                            <Col xl={6}>
                              <Label className="col-form-label">
                                {icdData?.icds?.created_by === "ADMIN"
                                  ? "Fund Requirement Date"
                                  : "Fund Availability Date"}
                              </Label>
                              <Input
                                disabled
                                type="text"
                                className="form-control"
                                id="horizontal-email-id "
                                placeholder="Fund Availability Date"
                                value={getFundRequirementDate(
                                  icdData?.icds?.fund_requirement_date
                                )}
                              />
                            </Col>
                            <Col xl={6}>
                              <Label className="col-form-label">
                                Repayment Schedule
                              </Label>
                              <Input
                                disabled
                                type="text"
                                className="form-control"
                                id="horizontal-email-id "
                                placeholder="Fund Requirement Date"
                                value={
                                  icdData?.icds &&
                                  repaymentSchedule.find(
                                    (item) =>
                                      item.key ===
                                      icdData?.icds?.repayment_schedule
                                  ).label
                                }
                              />
                            </Col>
                            {icdData?.repayment_schedule === "MULTIPLE" && (
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  No. Of Installments
                                </Label>
                                <Input
                                  name="repayment_terms"
                                  type="number"
                                  disabled
                                  className="form-control"
                                  id="repayment_terms"
                                  placeholder="Total Installments"
                                  value={icdData?.icds?.repayment_terms}
                                />
                              </Col>
                            )}
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              {icdData?.countered && (
                <Card style={{ boxShadow: "none" }}>
                  <CardBody className="pt-0">
                    <Row className="mb-2">
                      <CardTitle className="my-4">
                        Counter offer by{" "}
                        {offerType === "ADMIN" ? "investor" : "the admin"}
                      </CardTitle>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Investment Amount
                        </Label>
                        <Input
                          disabled
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={`₹ ${formatAmount(icdData?.amount)}`}
                        />
                      </Col>

                      <Col xl={6}>
                        <Label className="col-form-label">
                          Date of Repayment
                        </Label>
                        <Input
                          disabled
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Date of Repayment"
                          value={getDateOfRepayment(icdData?.repayment_date)}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Tenure(in days)
                        </Label>
                        <Input
                          disabled
                          type="text"
                          className="form-control"
                          placeholder="Tenure"
                          value={icdData?.tenure}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Interest Rate (%)
                        </Label>
                        <Input
                          disabled
                          type="text"
                          className="form-control"
                          placeholder="Interest Rate"
                          value={icdData?.interest_rate}
                        />
                      </Col>

                      <Col xl={6}>
                        <Label className="col-form-label">
                          Interest Payment Frequency
                        </Label>
                        <Input
                          disabled
                          type="text"
                          className="form-control"
                          placeholder="Interest Rate"
                          value={
                            interestFrequency.find(
                              (item) => item.key === icdData?.interest_frequency
                            ).label
                          }
                        />
                      </Col>

                      <Col xl={6}>
                        <Label className="col-form-label">
                          Fund Availability Date
                        </Label>
                        <Input
                          disabled
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Fund Availability Date"
                          value={getFundRequirementDate(
                            icdData?.fund_requirement_date
                          )}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Lock-in (in days)
                        </Label>
                        <Input
                          name="lockin_period"
                          type="number"
                          disabled
                          className="form-control"
                          id="lockin_period"
                          placeholder="Days"
                          value={icdData?.lockin_period}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Notice Period (in days)
                        </Label>
                        <Input
                          name="lockin_period"
                          type="number"
                          disabled
                          className="form-control"
                          id="lockin_period"
                          placeholder="Days"
                          value={icdData?.notice_period}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Repayment Schedule
                        </Label>
                        <Input
                          disabled
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Fund Requirement Date"
                          value={
                            repaymentSchedule.find(
                              (item) => item.key === icdData?.repayment_schedule
                            ).label
                          }
                        />
                      </Col>
                      {icdData?.repayment_schedule === "MULTIPLE" && (
                        <Col xl={6}>
                          <Label className="col-form-label">
                            No. Of Installments
                          </Label>
                          <Input
                            name="repayment_terms"
                            type="number"
                            disabled
                            className="form-control"
                            id="repayment_terms"
                            placeholder="Total Installments"
                            value={icdData.repayment_terms}
                          />
                        </Col>
                      )}
                    </Row>
                    {icdData?.comments && (
                      <Row className="mb-2">
                        <Col xl={12}>
                          <Label
                            htmlFor="horizontal-firstname-Input"
                            className="col-form-label"
                          >
                            Comments / Notes
                          </Label>
                          <Input
                            disabled
                            name="Name "
                            type="textarea"
                            className="form-control textarea"
                            id="horizontal-email-id "
                            placeholder="Comment"
                            value={icdData?.comments}
                          />
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              )}
              {["OPEN"].includes(icdData?.status) &&
                offerType === "INVESTOR" &&
                hasPermission(PERMISSIONS.ICD_UPDATE) && (
                  <>
                    <Row>
                      <Col xl={12}>
                        <div
                          className="buttons"
                          style={{
                            justifyContent: "center",
                            marginBlock: "10px",
                          }}
                        >
                          <Button
                            onClick={() => {
                              if (
                                userType === "ADMIN" &&
                                icdData?.investor?.entity_type === "INDIVIDUAL"
                              ) {
                                setOpenAlertModal(true)
                              } else {
                                setOpen(true)
                              }
                            }}
                            className="counteroffer"
                          >
                            Negotiate
                          </Button>
                          <Button
                            className="reject"
                            onClick={() => {
                              setIsToast(true)
                              setActionType("REJECT")
                            }}
                          >
                            Reject
                          </Button>
                          <Button
                            className="approve"
                            onClick={() => {
                              if (
                                userType === "ADMIN" &&
                                icdData?.investor?.entity_type === "INDIVIDUAL"
                              ) {
                                setOpenAlertModal(true)
                              } else {
                                setIsToast(true)
                                setActionType("APPROVE")
                              }
                            }}
                          >
                            Approve
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              {["COUNTER_OFFER", "DIRECT_ACCEPTANCE"].includes(
                icdData?.status
              ) &&
                offerType === "ADMIN" &&
                hasPermission(PERMISSIONS.ICD_UPDATE) && (
                  <>
                    <Row>
                      <Col xl={12}>
                        <div
                          className="buttons"
                          style={{
                            justifyContent: "center",
                            marginBlock: "10px",
                          }}
                        >
                          <Button
                            className="reject"
                            onClick={() => {
                              setIsToast(true)
                              setActionType("REJECT")
                            }}
                          >
                            Reject
                          </Button>
                          <Button
                            className="approve"
                            onClick={() => {
                              if (
                                icdData?.investor?.entity_type === "INDIVIDUAL"
                              ) {
                                setOpenAlertModal(true)
                              } else {
                                setIsToast(true)
                                setActionType("APPROVE")
                              }
                            }}
                          >
                            Approve
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
            </Container>
          )}
          {icdData && open && (
            <CounterFundRequestModal
              from="ADMIN"
              open={open}
              setOpen={setOpen}
              data={(() => {
                const { icds, investor, ...rest } = icdData
                return {
                  ...icds,
                  investor,
                  icdsRequest: rest,
                }
              })()}
              setCancelRequestOpen={() => {}}
              onSuccess={() => {
                onGetDetails()
                setOpen(false)
              }}
            />
          )}
          {icdData && isToast && actionType === "APPROVE" && (
            <ApproveConfirmationModal
              open={isToast}
              id={icdData.id}
              icdData={icdData}
              setOpen={setIsToast}
              isLoading={isApproving}
              onClose={() => {
                setIsToast(false)
                setActionType("")
              }}
              onApprove={onApprove}
              onSuccess={() => {
                onGetDetails()
                setIsToast(false)
              }}
            />
          )}

          {icdData && isToast && actionType === "REJECT" && (
            <RejectConfirmationModal
              open={isToast}
              id={icdData.id}
              setOpen={setIsToast}
              isLoading={isRejecting}
              onClose={() => {
                setIsToast(false)
                setActionType("")
              }}
              onReject={onReject}
              onSuccess={() => {
                onGetDetails()
                setIsToast(false)
              }}
            />
          )}
          {openAlertModal && (
            <AlertAccessModal
              open={openAlertModal}
              onClose={() => setOpenAlertModal(false)}
            />
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default InvestorRequestViewModel
